import React from "react";
import { Helmet } from "react-helmet";

import Navigation from "../components/navigation";
import Footer from "../components/footer";
import "./page-shell.css";

const Facility = () => {
  return (
    <div className="page-shell">
      <Helmet>
        <title>MDMC Facility</title>
        <meta property="og:title" content="MDMC Facility" />
      </Helmet>
      <Navigation></Navigation>
      <main>
        <section className="page-hero">
          <h1 className="page-hero-title">Collider Facility</h1>
          <p className="page-hero-subtitle">
            A public map of the MDMC product surface: generator, library,
            scoring bench, output feed, and partner properties.
          </p>
          <div className="page-cta">
            <a
              className="btn btn-primary btn-lg"
              href="https://tinyhost.xyz"
              target="_blank"
              rel="noopener noreferrer"
            >
              Host On Tinyhost
            </a>
            <a className="btn btn-secondary btn-lg" href="/output-zone">
              View Output Zone
            </a>
          </div>
        </section>
        <div className="page-panel">
          <h3>Facility Status</h3>
          <p>
            These are the public-safe chambers currently available on
            `mdmc.dev`. Use this page as the site map for visitors and client
            demos.
          </p>
          <div className="row g-3 mt-2">
            {[
              { label: "Meme Generator", value: "Live" },
              { label: "Dank Library", value: "78 topics" },
              { label: "Console", value: "Scoring bench" },
              { label: "Output Zone", value: "Public feed" },
            ].map((stat) => (
              <div className="col-md-3" key={stat.label}>
                <div className="page-panel" style={{ marginBottom: 0 }}>
                  <h3>{stat.label}</h3>
                  <p className="text-muted">{stat.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="page-panel">
          <h3>Facility Map</h3>
          <div className="reactor-map">
            {[
              [
                "Generator",
                "Create SFW meme variants without login.",
                "/meme-generator",
              ],
              [
                "Library",
                "Study Principia Memetica with rendered models.",
                "/library",
              ],
              ["Console", "Score a concept before creating it.", "/console"],
              [
                "Output Zone",
                "Inspect public variant families.",
                "/output-zone",
              ],
              [
                "Experiments",
                "Compare read-only experiment cards.",
                "/experiments/public",
              ],
              [
                "Access",
                "Request operator access for client/staging work.",
                "/signup",
              ],
            ].map(([label, copy, href]) => (
              <a className="reactor-node" href={href} key={label}>
                <strong>{label}</strong>
                <p>{copy}</p>
              </a>
            ))}
          </div>
        </div>
        <div className="page-panel">
          <h3>Partner Hub</h3>
          <p>
            MDMC is a public lobby for dankness and for the properties that
            orbit it. Use this page as the map; jump outward when the collider
            output is ready for a home.
          </p>
          <div className="partner-grid">
            <a
              className="partner-card"
              href="https://tx.wtf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Social</span>
              <strong>tx.wtf</strong>
              <p>
                Find more dankness on tx.wtf &mdash; the operational spine and
                social hub. Post, share, and discover memes with the community.
              </p>
            </a>
            <a
              className="partner-card"
              href="https://tinyhost.xyz"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Hosting</span>
              <strong>tinyhost.xyz</strong>
              <p>
                Host your memes, sites, and experiments on tinyhost.xyz &mdash;
                reliable, self-hosted infrastructure for dank operators.
              </p>
            </a>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  );
};

export default Facility;
